import { Routes, Route } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import AuthLayout from "@/layouts/AuthLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ExamPatternAndSyllabus from "@/pages/ExamPatternAndSyllabus";
import ProgramPage from "@/pages/Program";
import DubaiExperiencePage from "@/pages/DubaiExperience";
import FAQsPage from "@/pages/FAQs";
// import BlogPage from "@/pages/Blog";
import ContactPage from "@/pages/Legal/Contact";
import PrivacyPolicyPage from "@/pages/Legal/PrivacyPolicy";
import RefundPolicyPage from "@/pages/Legal/RefundPolicy";
import TermsConditionsPage from "@/pages/Legal/TermsConditions";
import NotFoundPage from "@/pages/NotFound";

import LoginPage from "@/pages/Login";
import ApplyForExamPage from "@/pages/ApplyForExam";
import DashboardPage from "@/pages/Dashboard";
import AdminDashboardPage from "@/pages/Admin";
import AdminLoginPage from "@/pages/Login/AdminLogin";
import SEOPage from "@/pages/Admin/SEO";
import RobotsSitemapPage from "@/pages/Admin/RobotsSitemap";
import ForgotPasswordPage from "@/pages/Login/ForgotPassword";
import BlogPage from "@/pages/Blog";
import BlogDetailPage from "@/pages/Blog/BlogDetailPage";
import AdminBlogsPage from "@/pages/Admin/blog";
import ReferralPage from "@/pages/Admin/ReferralPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/exam-pattern-and-syllabus" element={<ExamPatternAndSyllabus />} />
        <Route path="/program" element={<ProgramPage />} />
        <Route path="/dubai-experience" element={<DubaiExperiencePage />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/terms-conditions" element={<TermsConditionsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/cet-exam-admin-login-2000" element={<AdminLoginPage />}/>
      </Route>

      <Route path="/apply" element={<ApplyForExamPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute role="candidate">
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute role="admin">
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      />

      <Route
  path="/admin/seo"
  element={
    <ProtectedRoute role="admin">
      <SEOPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/robots-sitemap"
  element={
    <ProtectedRoute role="admin">
      <RobotsSitemapPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/blogs"
  element={
    <ProtectedRoute role="admin">
      <AdminBlogsPage />
    </ProtectedRoute>
  }
/>

<Route
  path="/referral"
  element={
    <ProtectedRoute role="admin">
      <ReferralPage />
    </ProtectedRoute>
  }
/>
    </Routes>
  );
}
